import { BusinessEntityDto } from '../businessEntity.dto';
import { BaseDto } from '../base.dto';
import { UserDto } from '../user.dto';

export class SurfboardMerchantOnboardingDto extends BaseDto {
  businessEntityId?: number;
  merchantId?: number;
  surfboardApplicationId?: string;
  webKybUrl?: string;
  onboardingStatus?: string;
  requestedUserId?: number
  businessEntity?: BusinessEntityDto;
  requestedUser?: UserDto;
}